import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import {
  useQueryGames,
  useQueryGameInfo,
} from '../../../hooks/API/useQueryGames';
import { useQueryProvider } from '../../../hooks/API/useQueryProviders';
import { formatCMSContent } from '../../../utils/templater';
import { randomGameIdSelector } from '../../../redux/reducers/app/configuration';
import { GAME_DETAIL } from '../../../constants/routeTemplates';

export const GAME_TITLE = 'gameTitle';
export const PROVIDER_TITLE = 'providerTitle';
export const PROVIDER_GAME_TITLES = 'providerGameTitles';

export const createGamesSEOTextFormatHook = () => {
  return function useHook() {
    const { gameId } = useParams();

    const randomGameId = useSelector(randomGameIdSelector);

    const queryGameInfo = useQueryGameInfo(gameId, {
      enabled: !!gameId && gameId !== randomGameId,
    });

    const providerId = queryGameInfo.data?.game?.provider;

    const queryProvider = useQueryProvider(providerId, {
      enabled: !!providerId,
    });
    const queryProviderGames = useQueryGames(
      {
        _limit: 3,
        provider: providerId,
      },
      {
        enabled: !!providerId,
      }
    );

    const providerGames = queryProviderGames.data?.items ?? [];
    const providerGameTitles = providerGames
      .map((game) => game.translationKey)
      .join(', ');

    return useCallback(
      (string) => {
        return formatCMSContent(string, {
          [GAME_TITLE]: queryGameInfo.data?.game?.translationKey,
          [PROVIDER_TITLE]: queryProvider.data?.translationKey,
          [PROVIDER_GAME_TITLES]: providerGameTitles,
        });
      },
      [queryGameInfo, queryProvider, providerGameTitles]
    );
  };
};

export const createDefaultSEOTextFormatHook = () => {
  return function useHook() {
    return useCallback((string) => string, []);
  };
};

const FACTORY_CONFIG = {
  [GAME_DETAIL]: createGamesSEOTextFormatHook,
};

export const createSEOTextFormatHook = (path) => {
  return (FACTORY_CONFIG?.[path] ?? createDefaultSEOTextFormatHook)();
};

export const useSEOTextFormat = () => {
  const { path } = useRouteMatch();
  const useSEOTextFormatForRoute = createSEOTextFormatHook(path);

  return useSEOTextFormatForRoute();
};
